const u = up.util;
const e = up.element;
up.LinkFollowIntent = class LinkFollowIntent {
    constructor(link, callback) {
        this._link = link;
        this._callback = callback;
        this._lastRequest = null;
        this._on('mouseenter mousedown touchstart', (event) => this._scheduleCallback(event));
        this._on('mouseleave', () => this._unscheduleCallback());
        up.fragment.onAborted(this._link, () => this._unscheduleCallback());
    }
    _on(eventType, fn) {
        up.on(this._link, eventType, { passive: true }, fn);
    }
    _scheduleCallback(event) {
        if (!up.link.shouldFollowEvent(event, this._link))
            return;
        this._unscheduleCallback();
        const applyDelay = (event.type === 'mouseenter');
        if (applyDelay) {
            let delay = this._parseDelay();
            this._timer = u.timer(delay, () => this._runCallback(event));
        }
        else {
            this._runCallback(event);
        }
    }
    _unscheduleCallback() {
        var _a;
        clearTimeout(this._timer);
        if ((_a = this._lastRequest) === null || _a === void 0 ? void 0 : _a.background)
            this._lastRequest.abort();
        this._lastRequest = null;
    }
    _parseDelay() {
        var _a;
        return (_a = e.numberAttr(this._link, 'up-preload-delay')) !== null && _a !== void 0 ? _a : up.link.config.preloadDelay;
    }
    _runCallback(event) {
        up.log.putsEvent(event);
        if (!up.fragment.isAlive(this._link))
            return;
        this._callback({ onRequestKnown: (request) => this._lastRequest = request });
    }
};
